import axiosInstance from './axiosInstance';

const mediaService = {
  list:      (params = {}) => axiosInstance.get('/admin/media', { params }),
  logUpload: (data)        => axiosInstance.post('/admin/media/log', data),
  remove:    (id)          => axiosInstance.delete(`/admin/media/${id}`),
};

export default mediaService;
